import { Directive, Input, HostListener } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { NormalReportService } from '../../services/normalreport.service';
import { LoaddingService } from '../../providers/loadding.service';
import { OrderDetailModel } from '../../models/orderdetail.model';
import { AppConfig } from '../../app/app.config';
import * as $ from 'jquery';
import { FixedExtend } from './../../config/fixed-extend';

//订单详情指令
//TQQ 2016-12-30
@Directive({ selector: '[orderdetail]' })
export class OrderDetailDirective {
    constructor(private modalctrl: ModalController,
        private loadding: LoaddingService) {
    }


    @Input("orderdetail") bettingId: string;
    @Input("orderType") orderType: number = 0;

    @HostListener('click') onMouseEnter() {
        this.getOrderDetail(this.bettingId, this.orderType);
    }

    private getOrderDetail(bettingId, orderType) {
        let modal = this.modalctrl.create(OrderDetailComponent, {
            bettingId: bettingId,
            orderType: Number(orderType) || 0
        });
        // modal.onWillDismiss(s => {
        // });
        modal.present();

    }

}

@Component({
    selector: 'order-detail',
    templateUrl: 'orderdetail.html',
    providers: [
        NormalReportService
    ]
})
export class OrderDetailComponent {

    bettingId = this.navparam.get("bettingId");
    orderType = Number(this.navparam.get("orderType")) || 0;
    order: OrderDetailModel = new OrderDetailModel();
    issueinfo: any = { BettingMoney: 0, PerPrice: 0, Multiple: 0 };
    medians = "";
    reward: number;
    BuyCount: number = 0;
    betItem = [];
    brickBonusModel: any;
    constructor(private viewctrl: ViewController,
        private navparam: NavParams,
        private normalreport: NormalReportService,
        private loadding: LoaddingService,
        private config: AppConfig,
        private indexExtend: FixedExtend
    ) {

    }
    username = this.config.getCurrentUser().UserName;

    //TQQ 2017-02-23
    ionViewDidLoad() {
        let load = this.loadding.showLoding();
        this.getOrderDetail().then(s => {
            this.loadding.closeLoading(load);
        });
    }

    //获取订单详情
    //TQQ 2017-01-02
    getOrderDetail() {
        return this.normalreport.getOrderDetail(this.bettingId, this.orderType).then(s => {
            this.order = s;
            if (this.orderType == 0) {
                this.order.Issues = this.order.Issues || [];
                this.issueinfo = this.order.Issues[0] || this.issueinfo;
                this.selectMedianName();
                this.rewardModel();
                this.BuyCount = this.issueinfo.PerPrice
                    ? this.issueinfo.BettingMoney / this.issueinfo.PerPrice / this.issueinfo.Multiple
                    : 0;
            } else {
                this.order.BettingInfoIssues = this.order.BettingInfoIssues || [];
                this.order.BettingItems = this.order.BettingItems || [];
                this.betItem = this.order.BettingItems.slice(0, 1);
                this.BuyCount = this.order.BettingItemCount || this.order.BettingItems.length;
                let issue = this.order.BettingInfoIssues[0];
                if (issue && issue.BettingItems) {
                    try {
                        let items = JSON.parse(issue.BettingItems);
                        this.brickBonusModel = items.length > 0 ? items[0].AwardMode : "";
                    } catch (e) {
                        this.brickBonusModel = "";
                    }
                }
            }
        });
    }

    //奖金模式
    //chen 2017-01-23
    //tqq update 2017-03-13
    rewardModel() {
        let sysconfig = this.config.getSysConfig();
        let lottery = this.config.getLotterys().find(s => s.LotteryCode == this.order.LotteryCode);
        let rewardUp = lottery.RewardUp ? lottery.RewardUp : sysconfig.RewardUp;
        var baseReward = sysconfig.BasicReward + (rewardUp - sysconfig.RewardUp);

        // this.reward = this.order.GraduationCount * sysconfig.PerGraduation + baseReward;
        this.reward = this.indexExtend.accAdd(this.indexExtend.accMul(this.order.GraduationCount, sysconfig.PerGraduation), baseReward);
    }

    //选位
    //chen 2017-01-23
    selectMedianName() {
        let result = [];
        let m1;
        if (this.order.LotteryTypeCode === "02")
            m1 = ["五位", "四位", "三位", "二位", "个位"];
        else if (this.order.LotteryTypeCode === "08")
            m1 = ["第1名", "第2名", "第3名", "第4名", "第5名", "第6名", "第7名", "第8名", "第9名", "第10名"];
        else
            m1 = ["万位", "千位", "百位", "十位", "个位"];
        if (this.order.LotteryTypeCode === "02") {

        }
        if (this.order.LotteryTypeCode === "03") {
            m1 = ["个位", "十位", "百位", "千位", "万位"];
            var j = m1.length - this.order.SelectMedian.length;
            for (var i = 0; i <= j; i++) {
                if (this.order.SelectMedian[i] === "1") {
                    result.push(m1[j - i]);
                }
            }
        } else {

            for (var i = 0; i < this.order.SelectMedian.length; i++) {
                if (this.order.SelectMedian[i] == "1") {
                    result.push(m1[i]);
                }
            }
        }
        this.medians = result.join("、");
    }


    //下拉重新加载
    //TQQ 2017-01-02
    doRefresh(refresher) {
        this.getOrderDetail();
        setTimeout(() => {
            refresher.complete();
        }, 2000);
    }

    dismiss() {
        this.viewctrl.dismiss();
    }

    //撤单回调
    //TQQ 2017-02-23
    callback = () => {
        this.getOrderDetail();
    }

}



// WEBPACK FOOTER //
// ./src/dires/orderdetail/orderdetail.directive.ts